module.exports = __webpack_public_path__ + "img/default.0e56cc7d.png";